import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { FeatureForm, FeatureFormData } from "../form/FeatureForm";
import { useFeatureToast, useFeaturePage, useFeatureEditing } from "../../pages/features/hook";
import { Toast } from "../../atoms/Toast";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: FeatureFormData) => void;
  defaultValues?: Partial<FeatureFormData>;
  featureId?: string;
  refetchFeatures?: () => void;
};

export const EditFeatureModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  featureId,
  refetchFeatures
}) => {
  const { toast, showToast, hideToast } = useFeatureToast();
  const { handleEditFeature } = useFeatureEditing(showToast, refetchFeatures);

  const handleFormSubmit = (data: FeatureFormData, onError: (message: string) => void) => {
    if (!featureId) {
      onError('Owner ID is missing.');
      return;
    }
    handleEditFeature(
      {
        name: data.name,
        name_kh: data.name_kh,
        name_zh: data.name_zh,
      },
      featureId,
      onError,
      () => {
        onSubmit?.(data);
        onClose(); // Close modal on successful submission
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Update Feature"
        onClose={onClose}
      >
        <FeatureForm key={featureId} handleSubmit={handleFormSubmit} defaultValues={defaultValues} mode="edit" />
      </ModalTemplate>
    </div>
  );
};
